import { useContext } from "react";
import { MetricsContext } from "@/src/context";

export const useMetrics = () => useContext(MetricsContext);